// extracted by mini-css-extract-plugin
export default {"dataBoxContainer":"IncomeAnalysisModal_dataBoxContainer__feRjE","dataBox":"IncomeAnalysisModal_dataBox__pH4g0","centerLine":"IncomeAnalysisModal_centerLine__jhwG3"};